import React from 'react'
import Dialog from 'material-ui/Dialog'
import {withStyles} from 'material-ui/styles/index'
import TextField from 'material-ui/TextField'
import Typography from 'material-ui/Typography'
import classNames from 'classnames'
import {FlowSummaryLastPanelItem, FlowSummaryPanelItem} from '../../flow'
import {Panel} from '../../../components'
import {viewAppointmentDialog as styles} from '../styles'
import moment from '../../../common/moment'
import IconButton from 'material-ui/IconButton'
import CloseIcon from 'material-ui-icons/Close'
import KeyboardArrowLeftIcon from 'material-ui-icons/KeyboardArrowLeft'
import config from '../../../config'
import {PRICES_AVAILABLE} from '../../../App'

class ViewAppointmentDialog extends React.Component {

  titlesByType = {
    0: '',
    1: 'Retiro programado',
    2: 'Envío programado',
    3: 'Retiro programado',
    4: 'Envío programado',
    5: 'Retiro programado',
  }

  detailTitleByType = {
    0: '',
    1: 'Retiro',
    2: 'Envío',
    3: 'Retiro',
    4: 'Envío',
    5: 'Retiro',
  }

  render() {
    const {classes, open, onClose, transaction} = this.props

    let where = ''
    let when = ''
    let cardData = ''
    let showOptions = false
    let transactionTypeID = 0
    let transactionPrice = 0
    let comment = ''
    let cancelText = ''

    if (transaction !== null) {
      where = transaction.ClientAddress.Address || 'Buenos Aires'

      // TODO The date coming from the server says its UTC but it's not. It's a bug in the server.
      const date = moment.utc(transaction.Reserve.Date)
        .hour(transaction.Reserve.TimeSlot.Hour)
        .minute(transaction.Reserve.TimeSlot.Minute)
      when = date.format('LLL')
      showOptions = date.isAfter(moment().utc().add(moment().utcOffset(), 'hour'))
      cardData = transaction.Card.ID === 0
        ? 'Pago offline'
        : transaction.Card.Type.charAt(0).toUpperCase() + transaction.Card.Type.slice(1) + ' terminada en ' + transaction.Card.LastDigits
      transactionTypeID = transaction.TransactionType.ID
      transactionPrice = transaction.Price
      comment = transaction.Comments
      cancelText = 'CANCELAR ' + this.detailTitleByType[transaction.TransactionType.ID].toUpperCase()
    }

    const apiKey = config.GOOGLE_MAPS_API_KEY

    return (
      <Dialog
        open={open}
        onClose={onClose}
        fullScreen={true}
        classes={{paper: classes.dialog}}
      >
        <div>
          <div className={classes.header}>
            <IconButton style={{opacity: 0}}><KeyboardArrowLeftIcon/></IconButton>
            <Typography variant={'body2'} color={'textSecondary'}>{this.titlesByType[transactionTypeID]}</Typography>
            <IconButton onClick={onClose}><CloseIcon/></IconButton>
          </div>
          <div className={classes.centerContainer}>
            <Panel style={{marginTop: 50}}>
              <iframe
                width="100%"
                height="205"
                frameBorder="0"
                style={{border: 0}}
                src={`https://www.google.com/maps/embed/v1/search?key=${apiKey}&q=${where}`}
                allowFullScreen
                title="location"
              >
              </iframe>
              <FlowSummaryPanelItem
                title={'Dirección'}
                description={where}
                actionLabel={''}
              />
              <FlowSummaryPanelItem
                title={'Día y horario'}
                description={when}
                actionLabel={''}
              />
              <FlowSummaryPanelItem
                title={'Método de pago'}
                description={cardData}
                actionLabel={''}
              />
              {PRICES_AVAILABLE &&
              <FlowSummaryLastPanelItem
                rows={[{
                  label: 'Costo de ' + this.detailTitleByType[transactionTypeID],
                  value: (transactionPrice === 0) ? '¡GRATIS!' : '$' + transactionPrice.toFixed(2),
                  valueColor: transactionPrice === 0 ? 'secondary' : undefined,
                }]}
              />
              }
            </Panel>

            <TextField
              id="notas"
              label="Notas"
              value={comment}
              margin="normal"
              disabled
              className={classes.comment}
            />

            {showOptions &&
            <LinkRed classes={classes} children={cancelText} onClick={() => this.props.onCancel(transaction)}/>
            }
          </div>
        </div>
      </Dialog>
    )
  }
}

const LinkRed = ({classes, children, onClick}) => (
  <Typography
    variant={'body2'}
    color={'error'}
    onClick={onClick}
    className={classNames(classes.Label, classes.cursorPointer)}
  >
    {children}
  </Typography>
)

export default withStyles(styles, {withTheme: true})(ViewAppointmentDialog)



// WEBPACK FOOTER //
// ./src/sections/activity/components/viewAppointmentDialog.js